import { Message } from 'element-ui';
var childRoute = ['/lhb-micro-pms']; // 子应用前缀
var isChildRoute = function (path) { return childRoute.some(function (item) { return path.startsWith(item); }); };
import { setCurrentRunningApp } from 'qiankun/es/sandbox/common';
export default function routerControl(router) {
    router.beforeEach(function (to, from, next) {
        if (isChildRoute(from.path) && !isChildRoute(to.path)) { // 判断如果是子应用跳转到父应用
            setCurrentRunningApp(null); // 清空当前应用设置，相当于重新加载
        }
        // 动态设置页面title
        if (to.meta.title) {
            document.title = to.meta.title;
        }
        else {
            process.env.NODE_ENV === 'development' && Message.error('为了方便数据采集，请添加title！');
        }
        // 路由为空时重定向回首页
        if (to.path === '/') {
            router.replace('/schedule');
        }
        else {
            next();
        }
    });
    router.afterEach(function (to, from) {
        if (process.env.NODE_ENV !== 'development') {
            // 先发送离开页面的信息 再上传进入页面的信息
            window.LHBbigdata.spa.beforeRouteLeave()(to, from);
            window.LHBbigdata.spa.beforeRouteEnter()(to, from);
        }
    });
}
